/**
 * TT-271. Canadian addresses. The backend lists Canada's provinces and
 * territories with the US states ("USA,CAN"); our ZIP lookup is US only, so a
 * Canadian postal code is checked by its shape instead.
 */
export const STATE_LIST_COUNTRIES = 'USA,CAN';

export const CANADIAN_PROVINCE_CODES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

/** A1A 1A1, with or without the space. */
const POSTAL_CODE = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

export const isCanadianPostalCode = (value?: string | null): boolean => POSTAL_CODE.test(value?.trim() ?? '');

export const isCanadianProvince = (code?: string | null): boolean =>
  !!code && CANADIAN_PROVINCE_CODES.includes(code.trim().toUpperCase());
